import { Injectable } from '@angular/core';

import { ColloquialAttributes } from '@shared/models/icommons.model';
import { Observable } from 'rxjs';
import { UserColloquialService } from './user-colloquial.service';

/**
 * Service used to pull the stream for colloquial attributes while entering to records module
 * any subsequent call will return the pre-existing stream kept in memory
 */
@Injectable({
  providedIn: 'root',
})
export class ColloquialResolverService {
  constructor(private userColloquialService: UserColloquialService) {}
  resolve(): Observable<ColloquialAttributes> {
    // fetch colloquial attributes for user country skey
    return this.userColloquialService.getUserColloquial();
  }
}
